<template>
<v-container class='input-text-size'>
   <CheckReconcilationCriteria :baseCrudKey="baseCrudKey"
   @loadCRUDList="handleCheckReconcilation"/>
   <template>
    <v-row>
    <v-col cols="6">
    <CRUDList
      ref="crudList"
      tableWrapperDynamicClassname='elevation-3 ma-3 pa-3 taxroll-table-wrapper'
      tableDynamicClassname='taxroll-custom-table'
      tableDynamicHeight='250'
      :headers='headers'
      :displayTopPagination="false"
      :canSave="true"
      :showDate="true"
      :showTotal="true"
      :canMove="true"
      :disableKeyboardFunc="false"
      :itemKey="'customkey'"
      :baseCrudKey="unreconcilledCrudKey"
      :defaultSortBy="defaultSortBy"
      :loadingData="gridLoading.flag"
      :loadingText="gridLoading.text"
      :footerTotalDisplayColumnWise="countTotalCheckAndAmount"
      :variableToChangeRowBgColor="dynamicRowBgColor"
      @emitSelectedItem="emitSelectedItem"
      @loadCRUDList="handleCheckReconcilation"
      @onDoubleClicked="reconcileItem"
      >
      </CRUDList>
      </v-col>
      <v-col cols="6">
    <CRUDList
      ref="crudList"
      tableDynamicHeight='250'
      tableWrapperDynamicClassname='elevation-3 ma-3 pa-3 taxroll-table-wrapper'
      tableDynamicClassname='taxroll-custom-table'
      :headers='headers'
      :displayTopPagination="false"
      :canSave="true"
      :showDate="true"
      :showTotal="true"
      :canMove="true"
       :showSelect="true"
       :selectedItems="selectedItems"
      @emitSelectedItem="emitSelectedItem"
      :disableKeyboardFunc="false"
      :baseCrudKey="reconcilledCrudKey"
      :loadingData="gridLoading.flag"
      :loadingText="gridLoading.text"
      :defaultSortBy="defaultSortByTwo"
       :variableToChangeRowBgColor="dynamicRowBgColor"
      @loadCRUDList="handleCheckReconcilation"
      @onDoubleClicked="unReconcileItem"
      :itemKey="'customkey'"
      >
      </CRUDList>
      </v-col>
    </v-row>

   </template>
   <CheckReconcilationFooter
      :reconcilledCrudKey="reconcilledCrudKey"
      :unreconcilledCrudKey="unreconcilledCrudKey"
      :baseCrudKey="baseCrudKey"
      :cashTotal="cashTotal"
      :checkTotal="checkTotal"
      :depositTotal="depositTotal"
      :isAllowEditCashTotalOnReconPage="allowEditCashTotalOnReconPage"
      @loadCRUDList="handleCheckReconcilation"
      @checkAmountChange="handleCheckAmountChange"
      @isTypeDecimal="isTypeDecimal"
      @cashTotalChange="handleCashTotalChange"
      @checkTotalChange="handleCheckTotalChange"
      :totalCheckCount="totalCheckCount"
      :selectedItems="selectedItems"
      :isBusy="isSavingRecon || gridLoading.flag"
      @savingChange="isSavingRecon = $event"
    />
    </v-container>
</template>

<script>
import {
  mapActions, mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import {
  amountToNumber,
  defaultGridLoading, manageGridLoading,
} from '../../../../../util/shared/vue-global';
import { getWorkstationNumber } from '../../../../../util/workstation-util';
import CRUDList from '../../../../common/base/crud-2.0/CRUDList.vue';
import { depositListComparator } from '../../paymentutils/checkReconOrder';
import { checkReconcilationHeaders } from '../../paymentutils/PaymentTransactionTableHeaders';
import CheckReconcilationCriteria from './CheckReconcilationCriteria.vue';
import CheckReconcilationFooter from './CheckReconcilationFooter.vue';

// 99 is the catch-all workstation for support / remote logins that aren't a real
// till (see payrix.util.js, which falls back to it when no workstation is set).
// Those users aren't reconciling a drawer of their own, so they still get all.
const SUPPORT_WKST = 99;

export default {
  name: 'checkreconcilation',
  data() {
    return {
      headers: checkReconcilationHeaders,
      unreconcilledCrudKey: 'checkUnReconcilled', // only contains isRecon flag = flase items
      reconcilledCrudKey: 'checkReconcilled', // only contains isRecon flag = true items
      baseCrudKey: 'commonCrudkey', // default store contains everything
      gridLoading: defaultGridLoading(),
      cashTotal: 0,
      checkTotal: 0,
      depositTotal: 0,
      totalCheckCount: 0,
      reconcileUnreconcileItems: [],
      isDecimalFlag: true,
      unreconcileCheckCount: 0,
      unreconcileCheckAmountTotal: 0,
      // positional, one entry per grid column (see checkReconcilationHeaders)
      countTotalCheckAndAmount: ['check Count:', null, null, null, 'Total:'],
      copyOfSelectedItems: [],
      searchSeq: 0,
      isSavingRecon: false,
    };
  },
  components: {
    CheckReconcilationCriteria,
    CRUDList,
    CheckReconcilationFooter,
  },
  created() {
    const configLoaded = this.loadConfig({ requiredScope: 'paymentConfig' });
    this.loadLists(configLoaded);
    this.setWkstList([]);
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria',
      'item',
      'items',
    ]),
    ...mapGetters(['todaysDate']),
    ...mapState({
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem,
      StoreSelItems: (state) => state.tax.taxCheckRecon.checkReconSelItems,

    }),
    itemsGetter() {
      const itemData = this.items(this.unreconcilledCrudKey);
      return itemData;
    },
    selectedItems: {
      get() {
        return this.StoreSelItems;
      },
      set(value) {
        this.setCheckReconSelItems(value);
      },
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'payDate',
          direction: 'desc',
        },
      ];
    },
    defaultSortByTwo() {
      return [
        {
          column: 'payDate',
          direction: 'desc',
        },
      ];
    },
    dynamicRowBgColor() {
      // Only return the background color configuration if the setting is enabled
      if (this.paymentSettingItem && this.paymentSettingItem.highlightCheckPaymentsWithNoImage) {
        return [{ varName: 'highlightNoFiles', varCol: '#82B1FF' }];
      }
      return [];
    },
    allowEditCashTotalOnReconPage() {
      if (this.paymentSettingItem && this.paymentSettingItem.allowEditCashTotalOnReconPage) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setIsVisible', 'setItem', 'setItems', 'setCriteria']),
    ...mapActions(['flashInfo', 'flashWarn', 'flashError', 'flashSuccess']),
    ...mapActions('SystemConfig', [
      'loadConfig',
    ]),
    ...mapMutations('tax/taxPayment', [
      'setWkstList',
    ]),
    ...mapMutations('tax/taxCheckRecon', [
      'setCheckReconSelItems',
    ]),
    ...mapActions('tax/taxPayment', [
      'loadWkstnList',
    ]),
    ...mapActions('tax/taxCheckRecon', [
      'loadTaxCheckRecon',
      'upsertTaxCheckRecon',
    ]),
    async handleCheckReconcilation() {
      if ((this.criteriaState.wkStns || []).length > 0) {
        // searches overlap (initial load, criteria changes, every reconcile); only the
        // newest one may fill the grids or a late older response overwrites fresh data
        this.searchSeq += 1;
        const seq = this.searchSeq;
        manageGridLoading(this, true, 'Searching...');
        const loadedItems = await this.loadTaxCheckRecon({
          criteria: { ...this.criteriaState },
          /*
            passing commoncrudKey as baseCrudKey
            where initially all items will be stored(reconcilled & unreconcilled)
          */
          baseCrudKey: this.baseCrudKey,
        }).finally(() => {
          if (seq === this.searchSeq) {
            manageGridLoading(this, false);
          }
        });
        if (seq !== this.searchSeq) {
          return;
        }
        this.reconcileUnreconcileItems = loadedItems;
        this.loadReconUnreconItems();
        this.setDefaultSelectedItems();
      } else {
        // invalidate any search still in flight so it can't repopulate the grids; it
        // will no longer clear the spinner either, so clear it here
        this.searchSeq += 1;
        manageGridLoading(this, false);
        // if no wkstn is selected, then we need to empty all stores
        this.setItems([this.baseCrudKey, []]);
        this.setItems([this.reconcilledCrudKey, []]);
        this.setItems([this.unreconcilledCrudKey, []]);
        this.setDefaultSelectedItems();
      }
    },
    loadReconUnreconItems() {
      const { unreconcilledCrudKey } = this;
      const { reconcilledCrudKey } = this;
      const reconciledItems = [];
      const unreconciledItems = [];
      let totalCheckAmt = 0;
      let totalCashAmt = 0;
      let totalChangeAmt = 0;
      let checkCount = 0;
      let unreconcileCheckCount = 0;
      let totalUnreconcileCheckAmt = 0;
      const trackPaymentNumberOfTotalchangeAmount = {};
      for (let i = 0; i < (this.reconcileUnreconcileItems || []).length; i += 1) {
        const item = this.reconcileUnreconcileItems[i];
        item.customkey = i;

        // Add highlightNoFiles property for check payments without files when setting is enabled
        if (this.paymentSettingItem && this.paymentSettingItem.highlightCheckPaymentsWithNoImage
            && item.paymentType === 'CHECK' && !item.hasFiles) {
          item.highlightNoFiles = true;
        }

        if (item.paymentType === 'CHECK') {
          // change on an overpaid check is handed back from the cash drawer,
          // so it reduces cash-on-hand the same way cash-payment change does
          if (!trackPaymentNumberOfTotalchangeAmount[item.paymentNumber]) {
            totalChangeAmt += item.totalChange;
            trackPaymentNumberOfTotalchangeAmount[item.paymentNumber] = item.totalChange;
          }
          if (item.isReconcilled !== true) {
            unreconciledItems.push(item);
            unreconcileCheckCount += 1;
            totalUnreconcileCheckAmt += item.amount;
          }
          if (item.isReconcilled === true) {
            totalCheckAmt += item.amount;
            checkCount += 1;
            reconciledItems.push(item);
          }
        }
        if (item.paymentType === 'CASH') {
          totalCashAmt += item.amount;
          if (!trackPaymentNumberOfTotalchangeAmount[item.paymentNumber]) {
            totalChangeAmt += item.totalChange;
            trackPaymentNumberOfTotalchangeAmount[item.paymentNumber] = item.totalChange;
          }
        }
      }
      // same comparator the Deposit List uses, so the grid and the printed list agree
      reconciledItems.sort(depositListComparator(this.paymentSettingItem));

      const cashAmt = amountToNumber(totalCashAmt - totalChangeAmt);
      this.checkTotal = totalCheckAmt;
      this.totalCheckCount = checkCount;
      this.unreconcileCheckCount = unreconcileCheckCount;
      this.unreconcileCheckAmountTotal = totalUnreconcileCheckAmt;
      // we need to display what cash is in treasury
      this.cashTotal = cashAmt;
      this.depositTotal = amountToNumber(cashAmt + totalCheckAmt);
      // we'll set items again on basis on isReconcilled flag to their respective stores
      this.setItems([unreconcilledCrudKey, unreconciledItems]);
      // we'll set items again on basis on isReconcilled flag to their respective stores
      this.setItems([reconcilledCrudKey, reconciledItems]);
      // Total sits under the Amount column, so this must line up with checkReconcilationHeaders
      this.countTotalCheckAndAmount = ['check Count:', unreconcileCheckCount, null, null, null, `Total: $ ${this.unreconcileCheckAmountTotal.toFixed(2)}`];
    },
    setDefaultSelectedItems() {
      this.$nextTick(() => {
        this.selectedItems = [];
      });
    },
    emitSelectedItem(id) {
      // const allItems = this.items(this.reconcilledCrudKey);
      this.selectedItems = id;
    },
    async handleCheckAmountChange(checkAmount) {
      const unreconciledItems = this.items(this.unreconcilledCrudKey);
      const typeDecimalFlag = this.isDecimalFlag;
      let matchCount = 0;
      const matchIndices = [];
      let inputAmount = 0.0;
      if (typeDecimalFlag) {
        // If the decimal flag is checked, the user input should already be in decimal format
        inputAmount = parseFloat(checkAmount).toFixed(2);
      } else {
        // If the decimal flag is not checked, treat the input as an integer
        // and convert it to decimal format
        inputAmount = (parseInt(checkAmount, 10) / 100).toFixed(2);
      }
      unreconciledItems.forEach((item) => {
        const amount = parseFloat(item.amount);
        if (Math.abs(amount - inputAmount) === 0) {
          matchCount += 1;
          matchIndices.push(item);
        }
      });
      if (matchCount === 0) {
        this.flashWarn('This amount is not found for Today!');
      } else if (matchCount > 1) {
        this.flashWarn('More Than One Check was found for Today! Double Click to Select.');
      } else {
        const item = matchIndices[0];
        const moved = await this.reconcileItem(item);
        if (moved) {
          this.flashSuccess('Check reconcilled successfully!');
        }
      }
    },
    // resolves true when the move was saved, false when it was refused or skipped
    async handleItem(item, targetCrudKey, isReconcileAll, isReconciledFlag) {
      // the order number below is read off the on-screen list, so a second move
      // before the list has refreshed would be numbered from stale rows
      if (this.isSavingRecon) {
        this.flashInfo('Still saving the previous check - try again in a moment.');
        return false;
      }
      const workstation = Number(item.workstation);
      if (targetCrudKey === this.reconcilledCrudKey && !(workstation > 0)) {
        this.flashError('This record has no workstation on file and cannot be reconciled. Contact support.');
        return false;
      }
      const itemCopy = { ...item };
      delete itemCopy.paymentDate;
      delete itemCopy.workstation;
      delete itemCopy.paymentNumber;
      delete itemCopy.checkNumber;
      delete itemCopy.paidBy;
      delete itemCopy.paymentType;
      delete itemCopy.cashTotal;
      delete itemCopy.amount;
      delete itemCopy.totalChange;
      delete itemCopy.hasFiles;
      delete itemCopy.highlightNoFiles;
      delete itemCopy.customkey;
      // read-only on the grid; the server stamps it, and taxCRPaymentsInputType has no such field
      delete itemCopy.reconciledAt;
      if (targetCrudKey === this.reconcilledCrudKey) {
        // sequence is per-workstation-per-day, not a global max across every workstation
        const reconciledItems = (this.items(this.reconcilledCrudKey) || [])
          .filter((i) => Number(i.workstation) === workstation);
        itemCopy.order = reconciledItems.length + 1;
      }

      itemCopy.wkStns = workstation;
      this.isSavingRecon = true;
      try {
        await this.upsertTaxCheckRecon({
          upserts: [itemCopy],
          isReconcileAll,
          isReconciledFlag,
        });
        await this.handleCheckReconcilation();
      } finally {
        this.isSavingRecon = false;
      }
      this.setDefaultSelectedItems();
      return true;
    },
    async unReconcileItem(item) {
      return this.handleItem(item, this.unreconcilledCrudKey, false, false);
    },
    async reconcileItem(item) {
      return this.handleItem(item, this.reconcilledCrudKey, true, false);
    },
    /*
      The workstation this session signed in on, or undefined when the filter
      should not be narrowed to it - support logins (wkst 99) and sessions with
      no workstation on file reconcile on behalf of everybody.
    */
    myWkstNumber() {
      let myWkst;
      try {
        myWkst = Number(getWorkstationNumber());
      } catch (e) {
        // localStorage can be unavailable (site data blocked); not worth
        // failing the whole screen over a filter default
        return undefined;
      }
      if (!(myWkst > 0) || myWkst === SUPPORT_WKST) {
        return undefined;
      }
      return myWkst;
    },
    /*
      A clerk normally only reconciles their own till, so default the By
      Workstation filter to the workstation they signed in on rather than every
      workstation. They can still widen it with Select All. Support logins
      (wkst 99, or no workstation on file) fall back to all.
    */
    defaultWkstnSelection(wkstNumList) {
      const wkstList = wkstNumList || [];
      if ((this.paymentSettingItem || {}).defaultWkstOnCheckRecon === 'all') {
        return [...wkstList];
      }
      const myWkst = this.myWkstNumber();
      /*
        the try/catch and the wkst 99 check moved to myWkstNumber() above, so
        wkstnListWithMine() can share them
      */
      // let myWkst;
      // try {
      //   myWkst = Number(getWorkstationNumber());
      // } catch (e) {
      //   return [...wkstList];
      // }
      // if (!(myWkst > 0) || myWkst === SUPPORT_WKST) {
      //   return [...wkstList];
      // }
      if (myWkst === undefined) {
        return [...wkstList];
      }
      // return the entry off the list itself so it matches the v-select's items
      const match = wkstList.find((wkst) => Number(wkst) === myWkst);
      /*
        taxCRStatsWkstList only reports workstations that have taken money
        before, so a till with no history at all isn't on it. Still default to
        it - widening to every workstation hands the clerk somebody else's
        checks, which is what we were asked to stop doing.
      */
      // if (match === undefined) {
      //   return [...wkstList];
      // }
      if (match === undefined) {
        return [myWkst];
      }
      return [match];
    },
    /*
      Make sure the signed-in workstation is one of the dropdown's items, so the
      default selection renders as a chip and can be picked again after the user
      clears it.
    */
    wkstnListWithMine(wkstNumList) {
      const wkstList = [...(wkstNumList || [])];
      const myWkst = this.myWkstNumber();
      if (myWkst === undefined || wkstList.some((wkst) => Number(wkst) === myWkst)) {
        return wkstList;
      }
      wkstList.push(myWkst);
      wkstList.sort((a, b) => Number(a) - Number(b));
      return wkstList;
    },
    async loadLists(configLoaded) {
      const [wkstNumList] = await Promise.all([this.loadWkstnList({}), configLoaded]);
      const wkstList = this.wkstnListWithMine(wkstNumList);
      if (wkstList.length !== (wkstNumList || []).length) {
        this.setWkstList(wkstList);
      }
      this.criteriaState.wkStns = this.defaultWkstnSelection(wkstList);
      this.$nextTick(() => {
        this.handleCheckReconcilation();
      });
      return this.criteriaState;
    },
    isTypeDecimal(val) {
      this.isDecimalFlag = val;
      return this.isDecimalFlag;
    },
    handleCashTotalChange(newCashTotal) {
      // Update the cashTotal in the parent component
      this.cashTotal = newCashTotal;
      // Recalculate the deposit total based on the updated cashTotal
      this.depositTotal = amountToNumber(newCashTotal + this.checkTotal);
      // Optional: Flash a success message
      this.flashInfo(`Cash Total updated to $${newCashTotal.toFixed(2)}`);
    },
    handleCheckTotalChange(newTotal) {
      // Update the Total in the parent component
      this.checkTotal = newTotal;
      // Recalculate the deposit total based on the updated cashTotal
      this.depositTotal = amountToNumber(newTotal + this.cashTotal);
      // Optional: Flash a success message
      this.flashInfo(`Deposit Total updated to $${newTotal.toFixed(2)}`);
    },
  },
};
</script>
